export default "__VITE_ASSET__C32gZKJw__"